import { useEffect, useState } from "react";
import classes from "../EditAutomations/ScheduledAction.module.css"
import RoundedInput from "../EditAutomations/RoundedInput";
import Button2 from "../../../Button/Button2";
import { Calendar } from "primereact/calendar";
import { setSiteAccessRestriction } from "../../../../../Api Methods/Api";
import { useDispatch, useSelector } from "react-redux";


const CreateAccessRestrictionUI = ({HandleCloseModal, fetchAutomations}) => {

    const [daysSelected, setdaysSelected] = useState( [0, 1, 2, 3, 4, 5, 6]);
    const [isAutomationActive, setIsAutomationActive] = useState(false);
    const [hour, setHour] = useState('12');
    const [minutes, setMinutes] = useState("00");
    const Days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const [editTime, setEditTime] = useState(false)

    const [startTime, setStartTime] = useState(new Date());
    const [endTime, setEndTime] = useState(new Date());

    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const dispatch = useDispatch();

    const apiData = {
        token,
        client
    }

    const handleChangeStartTime = (date) => {
        setStartTime(date);
    };

    const handleChangeEndTime = (date) => {
        setEndTime(date);
    };

    const HandleOnDayClicked= (dayIndex) => {
        const isDayAlreayClicked = daysSelected.includes(dayIndex);
        if (isDayAlreayClicked) {
            removeItem(dayIndex)
        } else {
            addItem(dayIndex)
        }
    }

    const removeItem = (dayIndex) => {
        const newArray = [...daysSelected];
        const filterArray = newArray.filter(Day => Day !== dayIndex)
        setdaysSelected(filterArray);
    }

    const addItem = (dayIndex) => {
        const newArray = [...daysSelected];
        newArray.push(dayIndex);
        setdaysSelected(newArray);
    };

    const setAccess = async () => {

        const formattedStartTime = startTime?.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });

        const formattedEndTime = endTime?.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });

        const body = {
            deviceUUID: DeviceUUID,
            days: daysSelected.map(String),
            startTime: formattedStartTime, 
            endTime: formattedEndTime,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }

        const response = await setSiteAccessRestriction(apiData, body, dispatch)
        if (response.success){
            //close
            HandleCloseModal();
            fetchAutomations();
        }
    }

    return (
        <div>
            <div className={classes.verticalFlex}>
                <div className={classes.verticalFlex}>                
                    <h4 style={{ margin: "0px", fontWeight: "400", width: "fit-content", color:"#6e6e6e" }} >Site access begins at</h4>
                    <Calendar placeholder={"Start time"} value={startTime} onChange={(e) => handleChangeStartTime(e.value)} timeOnly appendTo="self" />

                    <h4 style={{ margin: "0px", fontWeight: "400", width: "fit-content", color:"#6e6e6e" }} >Site access ends at</h4>
                    <Calendar placeholder={"End time"} value={endTime} onChange={(e) => handleChangeEndTime(e.value)} timeOnly appendTo="self" />
                </div >

                <div className={classes.verticalFlex}>
                    <h4 style={{ margin: "0px", fontWeight: "400", textAlign: "center", color:"#6e6e6e" }}>On:</h4>
                    <ul className={classes.horizontalFlex}>
                        {[0, 1, 2, 3, 4, 5, 6].map((dayIndex, index) => (
                            <li key={index}>
                                <Button2 style={{ backgroundColor: daysSelected.includes(dayIndex) && "var(--Primary-Color)", color: daysSelected.includes(dayIndex) && "white", minWidth:"60px", minHeight:"30px" }} onClick={() => HandleOnDayClicked(dayIndex)}>{Days[dayIndex]}</Button2>
                            </li>
                        ))}
                    </ul>

                    <h4 style={{ margin: "0px", fontWeight: "400", width: "fit-content", color:"#6e6e6e" }} >{`Unselect days you do not want to restrict`}</h4>

                </div>

                <div className={classes.verticalFlex} style={{ gap: "15px" }}>
                    <div style={{ display: "flex", 
                        flexDirection: "column", 
                        alignItems: "center", 
                        gap: "15px" 
                    }}>
                        <Button2 style={{ minWidth: "300px", marginTop: "10px" }} disabled={daysSelected.length === 0} onClick={setAccess} >
                            {"Save"}
                        </Button2>
                    </div>
                </div>
            </div >
        </div>
    )

}

export default CreateAccessRestrictionUI;